exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.integrationTopArea .leftArea[data-v-1e7d2ec1] {\n  width: 175px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-1e7d2ec1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/integrations/integratePopup/popupParts/topArea.vue
// module id = 2311
// module chunks = 0